import "core-js/es/map";
import "core-js/es/set";
import { polyfill } from "es6-promise";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { App } from "./components/app";
import { apiHost, history, store } from "./components/common/helpers";
import ScreensRoutes from "./screens/Routes";
import '../src/components/app/i18n';
polyfill();

const rootElement = document.getElementById("root");

const optionalFetch = (url, fallback, timeout = 3000) =>
  Promise.race([
    fetch(url).then((response) => {
      if (!response.ok) throw new Error(`Unable to load ${url}`);
      return response.json();
    }),
    new Promise((resolve) => setTimeout(() => resolve(fallback), timeout)),
  ]).catch(() => fallback);

const loadRuntimeConfig = () =>
  Promise.all([
    optionalFetch(`${apiHost}/api/client-config`, { mixpanel: { enabled: false } }),
    optionalFetch("/build_version.json", []),
  ]).then(([config, versions]) => {
    window.RUNTIME_MIXPANEL_CONFIG = config?.mixpanel || { enabled: false };
    const version = Array.isArray(versions) ? versions[0] : versions;
    window.RUNTIME_APP_VERSION = version
      ? `${version.version} (${version.build_no})`
      : undefined;
  });

loadRuntimeConfig().then(() => {
if (rootElement) {
  const root = createRoot(rootElement);

  root.render(
    <Provider store={store}>
      <HistoryRouter history={history}>
        <App MainComponent={ScreensRoutes} />
      </HistoryRouter>
    </Provider>
  );
}
});
